// extracted by mini-css-extract-plugin
module.exports = {"class":"Class_class__1g9Qd","active":"Class_active__4yRlZ"};